/* Nana Skincare theme scripts */
(function () {
  'use strict';
  var T = window.NanaTheme || {};

  function money(cents) {
    try {
      return (cents / 100).toLocaleString(T.locale || 'en-US', { style: 'currency', currency: T.currency || 'USD', minimumFractionDigits: cents % 100 === 0 ? 0 : 2 });
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Announcement rotation ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('.announcement__msg');
    if (msgs.length < 2) return;
    var i = 0, ms = parseInt(bar.dataset.interval, 10) || 5000;
    setInterval(function () { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, ms);
  });

  /* ---------- Drawers ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
  }
  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.drawerOpen); return; }
    if (e.target.closest('[data-drawer-close]')) { closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Carousels ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (c) {
    var track = c.querySelector('[data-carousel-track]');
    var bar = c.querySelector('[data-carousel-progress]');
    if (!track) return;
    function step() { var first = track.children[0]; return first ? first.getBoundingClientRect().width + 24 : track.clientWidth; }
    function update() {
      if (!bar) return;
      var max = track.scrollWidth - track.clientWidth;
      var visible = track.clientWidth / track.scrollWidth;
      bar.style.width = Math.max(visible * 100, 8) + '%';
      bar.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - visible * 100) : 0) + '%';
      var nav = c.querySelector('.carousel__nav'); if (nav) nav.style.display = max > 2 ? '' : 'none';
    }
    var prev = c.querySelector('[data-carousel-prev]'), next = c.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update); update();
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else { document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- Mobile: footer accordions start closed ---------- */
  if (window.matchMedia('(max-width: 749px)').matches) {
    document.querySelectorAll('[data-footer-col]').forEach(function (d) { d.removeAttribute('open'); });
  }

  /* ---------- Mobile: search icon focuses drawer search ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-focus-search]')) setTimeout(function () { var i = document.querySelector('#MenuDrawer input[type=search]'); if (i) i.focus(); }, 350);
  });

  /* ---------- Mobile: sticky add to bag ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var mainBtn = document.querySelector('[data-add-button]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', past); sticky.setAttribute('aria-hidden', !past);
    }).observe(mainBtn);
    sticky.querySelector('[data-sticky-atc-btn]').addEventListener('click', function () { mainBtn.click(); });
  }

  /* ---------- Tabs ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tab]'); if (!b) return;
      root.querySelectorAll('[data-tab]').forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on); });
      root.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.dataset.panel !== b.dataset.tab; });
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = (minus || plus).parentElement.querySelector('input');
    if (!input || input.hasAttribute('data-line-qty')) return;
    var min = parseInt(input.min || '0', 10), v = parseInt(input.value || '1', 10) + (plus ? 1 : -1);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Collection sort ---------- */
  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); location.href = u.toString(); });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.pdp__main-media img');
    g.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        g.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        main.removeAttribute('srcset'); main.src = btn.dataset.thumb;
      });
    });
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.parentElement.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product; try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var inputs = root.querySelectorAll('[data-option-input]');
    if (!inputs.length) return;
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-input]')) return;
      var selected = [];
      root.querySelectorAll('.option-group').forEach(function (fs) { var c = fs.querySelector('input:checked'); selected.push(c ? c.value : null); });
      var v = product.variants.find(function (variant) { return variant.options.every(function (o, i) { return o === selected[i]; }); });
      var btn = root.querySelector('[data-add-button]');
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; } return; }
      root.querySelector('[data-variant-id]').value = v.id;
      var price = root.querySelector('[data-pdp-price]');
      if (price) price.innerHTML = '<span class="price"><span class="price__now">' + money(v.price) + '</span>' + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '</span>';
      var size = root.querySelector('[data-pdp-size]'); if (size) size.textContent = v.title;
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to bag' : 'Sold out'; }
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
    });
  });

  /* ---------- Cart (AJAX + drawer) ---------- */
  var drawerBody = document.querySelector('[data-cart-drawer-body]');
  var drawerFoot = document.querySelector('[data-cart-drawer-foot]');

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count > 0 ? cart.item_count : ''; el.dataset.count = cart.item_count; });
    if (!drawerBody) return;
    if (!cart.item_count) {
      drawerBody.innerHTML = '<div class="cart-drawer__empty"><p>Your bag is empty.</p><a class="btn" href="/collections/all">Discover the rituals</a></div>';
      if (drawerFoot) drawerFoot.hidden = true;
      return;
    }
    drawerBody.innerHTML = cart.items.map(function (item, idx) {
      var img = item.image ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' + '" alt="">' : '<div class="ph"></div>';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="mini-line__meta">' + esc(item.variant_title) + '</div>' : '';
      return '<div class="mini-line"><a class="mini-line__img" href="' + item.url + '">' + img + '</a><div><a class="mini-line__title" href="' + item.url + '">' + esc(item.product_title) + '</a>' + variant +
        '<div class="qty"><button type="button" data-line-change="' + (idx + 1) + '" data-q="' + (item.quantity - 1) + '" aria-label="Decrease">−</button><input type="number" value="' + item.quantity + '" data-line-qty readonly aria-label="Quantity"><button type="button" data-line-change="' + (idx + 1) + '" data-q="' + (item.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
        '<div style="text-align:right">' + money(item.final_line_price) + '<br><button class="cart-line__remove" type="button" data-line-change="' + (idx + 1) + '" data-q="0">Remove</button></div></div>';
    }).join('');
    if (drawerFoot) {
      drawerFoot.hidden = false;
      var sub = drawerFoot.querySelector('[data-cart-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
      var ship = drawerFoot.querySelector('[data-ship-bar]');
      var th = T.freeShippingThreshold || 0;
      if (ship) {
        if (th > 0) {
          var pct = Math.min(100, Math.round(cart.total_price / th * 100));
          ship.innerHTML = (cart.total_price >= th ? 'You’ve unlocked complimentary shipping.' : 'You’re ' + money(th - cart.total_price) + ' away from complimentary shipping.') + '<div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div>';
        } else { ship.innerHTML = ''; }
      }
    }
  }
  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-ajax-cart]') || !drawerBody) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'); var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(fetchCart)
      .then(function (cart) { renderCart(cart); openDrawer('CartDrawer'); })
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Sorry, that item could not be added.'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && drawerBody && !document.body.classList.contains('template-cart')) {
      e.preventDefault(); fetchCart().then(function (c) { renderCart(c); openDrawer('CartDrawer'); }); return;
    }
    var ch = e.target.closest('[data-line-change]');
    if (ch) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: parseInt(ch.dataset.lineChange, 10), quantity: Math.max(0, parseInt(ch.dataset.q, 10)) }) })
        .then(function (r) { return r.json(); }).then(renderCart);
    }
  });

  /* ---------- Cart page: auto update on qty change ---------- */
  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    var t;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-update]')) return;
      clearTimeout(t); t = setTimeout(function () {
        var input = document.createElement('input'); input.type = 'hidden'; input.name = 'update'; input.value = '1'; cartForm.appendChild(input); cartForm.submit();
      }, 600);
    });
  }

  /* ---------- Product recommendations ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    if (el.children.length || !el.dataset.url || el.dataset.url.indexOf('product_id=&') > -1) return;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML; else el.remove();
    }).catch(function () { el.remove(); });
  });
})();
